module.exports = __webpack_public_path__ + "static/assets/600e72c6051e3788ba8de751bd6093c0.png";